<template>
  <div id="unit-container">
    <Title title="Units"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>

    <v-container>
      <v-row>
        <v-col sm="3">
          <span style="cursor: pointer" @click="onFilterUnits('registered')">
            <InsightCard :title="'Registered'" :count="totalRegistered" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer" @click="onFilterUnits('active')">
            <InsightCard :title="'Active'" :count="totalActive" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer" @click="onFilterUnits('inactive')">
            <InsightCard :title="'Inactive'" :count="totalInactive" />
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12">
          <UnitTable
            :headers="unitHeaders"
            :items="filteredUnits"
            :title="'unit.unit'"
            :modalText="'Unit'"
            :apiRoute="'units'"
            :isLoading="isUnitsLoading"
            @optionAdded="onOptionAdded"
          />
        </v-col>

        <v-col lg="12" md="12" sm="12">
          <UnitTable
            :type="'endorsedUnits'"
            :headers="unitHeaders"
            :items="endorsedUnits"
            :title="'Endorsed units'"
            :modalText="'Unit'"
            :apiRoute="'units'"
            :isLoading="isUnitsLoading"
            @optionAdded="onOptionAdded"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UnitTable from "../components/UnitTable";
import InsightCard from "../components/InsightCard";
import Title from "../components/Title";

export default {
  components: {
    UnitTable,
    InsightCard,
    Title,
  },
  mounted: function () {
    this.getUnits();

    // display snackbar after add or edit unit
    if (this.$route.params.message) {
      this.snackbarText = this.$route.params.message;
      this.snackbar = true;
    }
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      units: [],
      filteredUnits: [],
      endorsedUnits: [],
      isUnitsLoading: true,
      headers: [
        { text: "Code", value: "code" },
        { text: this.$t("unit.name"), value: "name" },
        { text: this.$t("unit.uan"), value: "uan" },
        { text: this.$t("unit.level"), value: "level" },
        { text: this.$t("unit.credits"), value: "credits" },
        { text: "Status", value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    unitHeaders: function () {
      if (this.$store.state.role == "centre") {
        const headers = [];

        for (let i = 0; i < this.headers.length; i++) {
          if (this.headers[i].value.toLowerCase() != "actions") {
            headers.push(this.headers[i]);
          }
        }
        return headers;
      }

      return this.headers;
    },
    totalRegistered: function () {
      return this.units.length;
    },
    totalActive: function () {
      const totalActive = this.units.filter((unit) => {
        return unit.status.toLowerCase() == "active";
      });

      return totalActive.length;
    },
    totalInactive: function () {
      const totalInactive = this.units.filter((unit) => {
        return unit.status.toLowerCase() == "inactive";
      });

      return totalInactive.length;
    },
  },
  watch: {
    isUnitsLoading: function (newValue) {
      this.isUnitsLoading = newValue;
    },
  },
  methods: {
    getUnits: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/units`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.filteredUnits = data.units;

          for (let i = 0; i < data.units.length; i++) {
            if (data.units[i].type.toLowerCase() == "endorsed") {
              this.endorsedUnits.push(data.units[i]);
            } else {
              this.units.push(data.units[i]);
            }
          }

          this.isUnitsLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onOptionAdded: function (data) {
      this.getUnits();

      this.snackbarText = data.message;
      this.snackbar = true;
    },
    onFilterUnits: function (type) {
      if (type == "registered") {
        this.filteredUnits = this.units;
        return;
      }

      this.filteredUnits = this.units.filter((unit) => {
        return unit.status.toLowerCase() == type;
      });
    },
  },
};
</script>

<style scoped>
h3 {
  display: inline-block;
}

#unit-container {
  min-height: 100vh;
}
</style>